import Icon from "@components/ui/icon";
import { useAppDispatch } from "@store";
import { closeDialog } from "@store/dialogs";

const ID = "delete-version-lock";
const DeleteVersionLockDialog = ({ type }: { type: "version" | "session" }) => {
  const dispatch = useAppDispatch();
  const handleClose = () => dispatch(closeDialog(ID));

  return (
    <div className="tw-max-w-[400px] tw-rounded-2xl tw-bg-white tw-p-6 tw-shadow-md">
      <div className="tw-mb-2 tw-flex tw-items-center tw-justify-between">
        <p className="tw-mb-0 tw-font-sans tw-text-lg tw-font-semibold tw-text-blue">
          You cannot delete this {type === "version" ? "version" : "session"}
        </p>
        <button
          onClick={handleClose}
          className="tw-flex tw-size-4 tw-cursor-pointer tw-items-center tw-justify-center tw-outline-none tw-transition-opacity hover:tw-opacity-80"
        >
          <Icon icon="ri-close-line" className="tw-text-blue" />
        </button>
      </div>
      <p className="tw-mb-0 tw-font-sans tw-text-sm tw-text-blue-700">
        Only creator or account admin can delete this{" "}
        {type === "version" ? "version" : "session"}. Please contact your admin
        or{" "}
        <a
          href="mailto:support@storydoc.com"
          className="tw-text-primary tw-no-underline tw-transition-opacity hover:tw-opacity-90"
        >
          reach out to Storydoc Support
        </a>{" "}
        for assistance.
      </p>
    </div>
  );
};

DeleteVersionLockDialog.id = ID;
export { DeleteVersionLockDialog };
